import React from "react";

const BackArrowIcon = (props) => {
  const { navigateToBuilderListPage } = props;
  return (
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      onClick={() => navigateToBuilderListPage()}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.99976 1L0.999755 7L6.99976 13"
        stroke="#5C5F62"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BackArrowIcon;
